import CoreBase from '../../../../../services/engines/CoreBase';

class DropHandler extends CoreBase {
    _name = 'DropHandler';

    /**
     * Handles jerny:drop — forwards drop result back to iframe via postMessage.
     * Parent acts as relay: iframe sends drop event up, parent sends dropresult back down.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     */
    handle = (e, iframe) => {
        try {
            iframe?.contentWindow?.postMessage({
                type: 'jerny:dropresult',
                ems: e.data.ems,
                dp: e.data.dp,
                isCtrlDown: e.data.isCtrlDown,
            }, '*');
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const dropHandler = new DropHandler();
export default dropHandler;
